function countdown( elementName, minutes, seconds ){
    var element, endTime, hours, mins, msLeft, time;
    function twoDigits( n ) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if ( msLeft < 1000 ) {
            element.innerHTML = "Time is up!";
        } else {
            time = new Date( msLeft );
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
            setTimeout( updateTimer, time.getUTCMilliseconds() + 500 );
        }
    }

    element = document.getElementById( elementName );
    endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
    updateTimer();
}
 
$('document').ready(function(){
  $("[data-modal]").on('click', function(){
     var modalID = $(this).attr("data-modal");
     $('.custom-modal#'+modalID).addClass('show');
  });
  
  $('.custom-modal__close').on('click', function(){
    $(this).parents('.custom-modal').removeClass('show');
  });
});

jQuery('.order--product').click(function(e){
  e.preventDefault();
  let productID = jQuery('.order--product-ID').val();
  if(productID){
     $.ajax({
          type: 'POST',
          url: window.Shopify.routes.root + 'cart/add.js',
          dataType: 'json',
          data: {'id': productID, 'quantity': 1 },
          success: function (response) {
              console.log('Success:', response);               
              window.location.href = '/checkout?express';
          },
          error: function (xhr, status, error) {
              console.error('Error:', error);
          }
      });
  }
  });
jQuery(document).ready(function(){
  if(jQuery('body').hasClass('product')){   
        jQuery('#prvw__bundle_container').hide();
        var groupedQuantity = jQuery('#prvw__bundle_container').html();
        if(groupedQuantity){
          jQuery('.product-form__buttons_new').before('<div class="prvw__bundle_container">'+groupedQuantity+'</div>');
        }      

       jQuery('.block__cbwrapper .block__cb input#cb1').attr('checked',true);      
       jQuery('.block__cbwrapper .block__cb label').on('click',function(e){
          jQuery('.block__cbwrapper .block__cb input').removeAttr('checked');
          jQuery(this).parent().find('input').attr('checked',true);
        });

        jQuery('label.ROS-radio-button-click-target-3').on('click',function(){
            jQuery('.prvw__bundle_container').addClass('content-disabled');
        });

function countdownByClass(className, hours, minutes, seconds) {
    var elements = document.getElementsByClassName(className);
    if (elements.length === 0) {
        console.error("Element with class '" + className + "' not found.");
        return;
    }

    var endTime, hours, mins, msLeft, time;

    function twoDigits(n) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if (msLeft < 1000) {
            for (var i = 0; i < elements.length; i++) {
               document.getElementById('countdown-container').style.display='none';
            }
        } else {
            time = new Date(msLeft);
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            var timeString = (hours ? hours + 'h ' + twoDigits(mins) : mins) + 'm ' + twoDigits(time.getUTCSeconds()) + 's';

            for (var i = 0; i < elements.length; i++) {
                elements[i].innerHTML = timeString;
            }

            setTimeout(updateTimer, 1000);
        }
    }

    endTime = (+new Date) + 1000 * (3600 * hours + 60 * minutes + seconds);
    updateTimer();
}
  
  countdownByClass("countdown", 6, 0, 0);
  const deliveryDate = new Date();
  const threeDaysLater = deliveryDate.getDate() + 3;
  deliveryDate.setDate(threeDaysLater)
  const options = { weekday: 'long', month: 'long', day: 'numeric'};
  const formattedDate = deliveryDate.toLocaleDateString('en-US', options);
  document.querySelectorAll('.daycount').forEach(element => {
      element.innerText = formattedDate;
  });

    
  }
});